import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);
  // true depois de o usuário clicar em "Sair" (ver sair/RotaProtegida): o login seguinte não volta para a página de antes
  const [saiuDeProposito, setSaiuDeProposito] = useState(false);

  const verificarSessao = useCallback(async () => {
    try {
      const { usuario } = await api.get('/auth/me');
      setUsuario(usuario);
    } catch {
      setUsuario(null);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    verificarSessao();
  }, [verificarSessao]);

  async function entrar(email, senha) {
    const { usuario } = await api.post('/auth/login', { email, senha });
    setSaiuDeProposito(false);
    setUsuario(usuario);
    return usuario;
  }

  async function sair() {
    await api.post('/auth/logout').catch(() => {});
    // Saída pedida pelo usuário: o RotaProtegida NÃO deve guardar a página atual como "destino pós-login" (quem entra
    // depois pode ser outro usuário, sem acesso a ela). Já a sessão que EXPIRA continua devolvendo à página.
    setSaiuDeProposito(true);
    setUsuario(null);
  }

  // Usado só pela troca de senha forçada (ver pages/TrocarSenha.js) —
  // depois de trocar com sucesso, o backend já desbloqueou a MESMA sessão
  // (session.js `atualizarSessao`), só falta refletir isso aqui pro
  // `RotaProtegida` parar de redirecionar pra `/trocar-senha`.
  function atualizarUsuario(usuarioAtualizado) {
    setUsuario(usuarioAtualizado);
  }

  // Sessão expira no servidor (KV do cookie vence) enquanto o usuário
  // está usando o app — `src/lib/api.js` dispara este evento em QUALQUER
  // 401, e aqui desloga localmente sem precisar chamar `/auth/logout` de
  // novo (a sessão já morreu no servidor). `RotaProtegida` já redireciona
  // pro login sozinho assim que `usuario` vira `null`.
  useEffect(() => {
    function aoExpirar() {
      setUsuario(null);
    }
    window.addEventListener('painel:sessao-expirada', aoExpirar);
    return () => window.removeEventListener('painel:sessao-expirada', aoExpirar);
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, carregando, saiuDeProposito, entrar, sair, atualizarUsuario }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
